import corporateSettings from 'corporateSettings.json';
import { getCurrentSubdomain } from './general';

const getCurrentPartnerSettings = () => corporateSettings.find(({ subdomain }) => subdomain === getCurrentSubdomain());

export const getPremiumItemValue = (item, isAnnual, partnerSettings = getCurrentPartnerSettings()) => {
  if (!isAnnual || partnerSettings?.use_contract_value_on_annual_prints !== true) return item?.value;
  return item?.contractValue ?? item?.value;
};

export const shouldDisplayFidelityDiscount = ({ capabilities, discountType, discount, modality }) =>
  capabilities?.showFidelityDiscount !== false &&
  discountType === 'fidelity' &&
  Boolean(discount) &&
  modality !== 'monthly';
